import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import cccLogo from '../../assets/ccc-logo.png';
import { v2Colors } from '../design/theme';

export default function V2UpdateOverlay({ percent = 0 }) {
  const value = Math.min(100, Math.max(0, Math.round(Number(percent) || 0)));

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        bgcolor: v2Colors.canvas,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        pt: '5vh',
      }}
    >
      <Box
        component="img"
        src={cccLogo}
        alt="Country Chicken Co"
        sx={{ width: 'max-content', maxWidth: '70vw', mb: 2 }}
      />
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
        <CircularProgress
          variant="determinate"
          size={100}
          value={value}
          sx={{ color: v2Colors.primary, p: 2.5 }}
        />
        <Typography
          sx={{
            position: 'absolute',
            fontFamily: '"Foregen", "Roboto Slab", Georgia, serif',
            fontSize: 35,
            color: v2Colors.primary,
          }}
        >
          {`${value}%`}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: '"Foregen", "Roboto Slab", Georgia, serif',
          color: v2Colors.primary,
          fontSize: 25,
          textAlign: 'center',
        }}
      >
        Please wait…
        <br />
        Loading your app...
      </Typography>
    </Box>
  );
}
